import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  serverHostname: validationNotEmpty("Server Hostname"),
  status: validationNotEmpty("Status"),
  serverUrl: validationNotEmpty("Server URL"),
});